import React, { Component } from 'react'
import { connect } from 'react-redux'
import DefaultPage from '../../../../Container/Layout/DefaultPage'
import AdminGridList from '../View/AdminGridList'
import AdminConfirmedEventsDetails from './AdminConfirmedEventDetails'
import { confirmedEventsListener } from '../adminEventsAPI'
import * as routes from '../../../../constants/routes'
import InAppNav from '../../../InAppNav/InAppNav'

const arraySort = require('array-sort');

const headline = {
    headlineText: 'Abgeschlossene Vermittlungen',
    subheadline: 'Daten werden geladen Laden.....'
}
class AdminConfirmedEvents extends Component {
    constructor() {
        super()
        this.state = {
            view: 'list',
            openEvent: null,
        }
    }
  
    componentDidMount() {
        confirmedEventsListener('on')

    }
    componentWillUnmount() {
        confirmedEventsListener('off')
    }

    toggleView = (view, event) => {
        if(view==='details') {
            return alert('Dieses Hilfegesuch wurde erfolgreich vermittelt und kann nicht mehr geändert werden')

        } else {
            this.setState({view: 'list'})
        }
    }

    sortedEvents = () => {
        const { confirmedEvents} = this.props
        const sortedEvents = arraySort(confirmedEvents, 'event.date')
        const arrayReverse = sortedEvents.reverse()
        return arrayReverse
    }
    render () {
        const { view } = this.state
        return (
            <DefaultPage headline={headline}>
                <InAppNav links={[{name:'Admin Home', route: routes.ADMINHOME}]}/>  
                {this.props.confirmedEvents===null || view==='details'
                    ? null
                    : <AdminGridList events={this.sortedEvents()} type='confirmed' toggleView={this.toggleView}/>
                }
                {view==='details'
                    ? <AdminConfirmedEventsDetails event={this.state.openEvent} toggleView={this.toggleView}/>
                    : null
                }
            </DefaultPage>
        )
    }
}

const mapStateToProps = (state) => ({
    confirmedEvents: state.eventState.confirmedEvents
})

export default connect(mapStateToProps)(AdminConfirmedEvents)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminConfirmedEvents/AdminConfirmedEvents.js